import { inject, Pipe, PipeTransform } from '@angular/core';
import { STRIP_ONTOLOGY_PREFIX } from '../../application/ports/strip-ontology-prefix.token';

@Pipe({ name: 'stripPrefix', standalone: true })
export class StripPrefixPipe implements PipeTransform {
  private readonly enabled = inject(STRIP_ONTOLOGY_PREFIX);

  transform(value: string, format: 'short' | 'full' = 'short'): string {
    if (!this.enabled) {
      return value;
    }
    const lastUnderscore = value.lastIndexOf('_');
    if (lastUnderscore === -1) {
      return value;
    }
    const name = value.substring(lastUnderscore + 1);
    if (format === 'full') {
      const prefix = value.substring(0, lastUnderscore);
      return `${name} (${prefix})`;
    }
    return name;
  }
}
